module.exports = __webpack_public_path__ + "img/main2.c47dc6a7.png";